// Photography data: albums and photo collections

export interface Photo {
  image: string
  title: string
  location: string
  camera: string
}

export interface Album {
  id: string
  title: string
  location: string
  category: string
  year: string
  coverImage: string
  description: string
  photos: Photo[]
}

export const ALBUMS: Album[] = [
  {
    id: 'urban-japan',
    title: 'URBAN EXPLORATION',
    location: 'JAPAN',
    category: 'STREET',
    year: '2023',
    coverImage: 'https://assets.codepen.io/7558/portrait-fashion-001.jpg',
    description: 'A study of neon lights, concrete canyons, and the quiet moments between the chaos of Tokyo and Kyoto.',
    photos: [
      { image: 'https://assets.codepen.io/7558/portrait-fashion-001.jpg', title: 'URBAN PORTRAIT', location: 'TOKYO', camera: 'SONY A7IV' },
      { image: 'https://assets.codepen.io/7558/portrait-fashion-002.jpg', title: 'SERENITY', location: 'KYOTO', camera: 'CANON R5' },
    ],
  },
  {
    id: 'euro-landscape',
    title: 'EUROPEAN VISTAS',
    location: 'EUROPE',
    category: 'LANDSCAPE',
    year: '2021-2022',
    coverImage: 'https://assets.codepen.io/7558/portrait-fashion-002.jpg',
    description: 'Capturing the golden hours and architectural marvels stretching from Santorini to Copenhagen.',
    photos: [
      { image: 'https://assets.codepen.io/7558/portrait-fashion-002.jpg', title: 'GOLDEN HOUR', location: 'SANTORINI', camera: 'CANON R5' },
      { image: 'https://assets.codepen.io/7558/portrait-fashion-004.jpg', title: 'MINIMALIST', location: 'COPENHAGEN', camera: 'FUJI GFX100' },
      { image: 'https://assets.codepen.io/7558/portrait-fashion-007.jpg', title: 'REFLECTIONS', location: 'VENICE', camera: 'LEICA M11' },
      { image: 'https://assets.codepen.io/7558/portrait-fashion-001.jpg', title: 'CONTRAST', location: 'BERLIN', camera: 'SONY A7IV' },
    ],
  },
  {
    id: 'global-streets',
    title: 'GLOBAL STREETS',
    location: 'WORLD',
    category: 'DOCUMENTARY',
    year: '2023',
    coverImage: 'https://assets.codepen.io/7558/portrait-fashion-003.jpg',
    description: 'The rhythm of street life across major metropolises. People, motion, and raw scenes.',
    photos: [
      { image: 'https://assets.codepen.io/7558/portrait-fashion-003.jpg', title: 'STREET LIFE', location: 'NEW YORK', camera: 'LEICA M11' },
      { image: 'https://assets.codepen.io/7558/portrait-fashion-006.jpg', title: 'NEON NIGHTS', location: 'SEOUL', camera: 'CANON R5' },
      { image: 'https://assets.codepen.io/7558/portrait-fashion-003.jpg', title: 'MOTION', location: 'LONDON', camera: 'LEICA M11' },
    ],
  },
  {
    id: 'abstract-forms',
    title: 'ABSTRACT FORMS',
    location: 'VARIOUS',
    category: 'ABSTRACT',
    year: '2020-2022',
    coverImage: 'https://assets.codepen.io/7558/portrait-fashion-008.jpg',
    description: 'Finding geometry, texture, and shadows in the mundane and the magnificent.',
    photos: [
      { image: 'https://assets.codepen.io/7558/portrait-fashion-008.jpg', title: 'TEXTURE', location: 'REYKJAVIK', camera: 'FUJI GFX100' },
      { image: 'https://assets.codepen.io/7558/portrait-fashion-005.jpg', title: 'SHADOWS', location: 'MARRAKECH', camera: 'SONY A7IV' },
      { image: 'https://assets.codepen.io/7558/portrait-fashion-004.jpg', title: 'GEOMETRY', location: 'DUBAI', camera: 'FUJI GFX100' },
    ],
  },
]

export const PHOTOGRAPHY_META = {
  backBtnText: '[ BACK TO ALBUMS ]',
  title: 'Photography Portfolio',
  socialLinks: [
    { label: 'Instagram', url: 'https://instagram.com' },
    { label: 'Email', url: 'mailto:photo@example.com' },
    { label: '500px', url: 'https://500px.com' },
  ],
  coordinates: '43.9250° N, 19.5530° E',
}
